/**
 * Created by claudio iozzia on 04/05/2017.
 */
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {IBounds, Ic, IEntityAlert, ITranslatedObj} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {EntityError} from "../../../../models/EntityAlert";
import {Utils} from "../../../../common/utils";
import {ISingleOutput} from "../../../../models/ISpec";
import {isEuropeRangeXFlyback} from "../../../../components/specification/v-input/preset/InputACPreset";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {Validator_Common} from "../../../../models/validator/validator_common";

export class Validator_AcDc_QR_Flyback extends Validator_Common {
  private validatorFn_SingleOutput_Voltage_QR_Flyback: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    const minPower: number = Utils.getFieldValue(ic, "validator.power.min", 0);
    const voutMin: number = Math.max(ic.vout_min, minPower / ic.iout_max);
    const _vOut = spec.spec.value.output.outputs[o].voltage;

    result = Utils.acceptInRange(_vOut, voutMin, ic.vout_max, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_QR_Flyback: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    const _iOut = spec.spec.value.output.outputs[o].current;
    const bound = this.currentBoundFromPower_QR_FlyBack(ic, spec, spec.spec.value.output.outputs[o]);

    result = Utils.acceptInRange(_iOut, bound.min, bound.max, "Iout", "A");
    return new EntityError(result);
  }

  private currentBoundFromPower_QR_FlyBack(ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): IBounds {
    const _vMin = spec.spec.value.input.min;
    const _vMax = spec.spec.value.input.max;

    const minPower: number = Utils.getFieldValue(ic, "validator.power.min", NaN);
    const maxPower: number = Utils.getFieldValue(ic, isEuropeRangeXFlyback(_vMin) ? "validator.power.maxEurope" : "validator.power.maxWide", NaN);

    const minVout: number = Utils.getNumberDefaultable(out.voltage, ic.vout_min);
    const maxVout: number = Utils.getNumberDefaultable(out.voltage, ic.vout_max);

    const minIout: number = ValueFormatter.scale((minPower / maxVout), siPrefix.unit, 2);
    const maxIout: number = ValueFormatter.scale((maxPower / minVout), siPrefix.unit, 2);
    const _iOutMax: number = Utils.getFieldValue(ic, "iout_max", Number.POSITIVE_INFINITY);

    return {min: minIout, max: Math.min(maxIout, _iOutMax)};
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_QR_Flyback].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_QR_Flyback].concat(super.singleOutputI());
  }
}
